import { render, staticRenderFns } from "./ShiftUserDetailsComponent.vue?vue&type=template&id=320cbe4f&"
import script from "./ShiftUserDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./ShiftUserDetailsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports